import { createSelector } from 'reselect';
import _sumBy from 'lodash/sumBy';

import { getShopDayDowntimeIntervals } from 'lib/selectors/getShopDayDowntimeIntervals';
import { getStartOfCurrentShopDay } from 'lib/selectors/getStartOfCurrentShopDay';
import { chopBefore } from 'lib/utils/intervals';
import { millis } from 'lib/utils/date';

const getTotalShopDayDowntime = createSelector(
  [getShopDayDowntimeIntervals, getStartOfCurrentShopDay],
  (shopDayDowntimeIntervals, startOfCurrentShopDay) => {
    if (
      !shopDayDowntimeIntervals ||
      shopDayDowntimeIntervals.length <= 0 ||
      !startOfCurrentShopDay
    ) {
      return null;
    }

    // Clip intervals to shop day boundaries for duration calculation
    const clippedIntervals = chopBefore(
      shopDayDowntimeIntervals,
      startOfCurrentShopDay
    );

    return _sumBy(clippedIntervals, (downtime) => {
      const startMs = millis(downtime.start);
      const endMs = downtime.end ? millis(downtime.end) : millis();
      return Math.round((endMs - startMs) / 1000);
    });
  }
);

export { getTotalShopDayDowntime };
